import axios, {AxiosResponse} from 'axios'
// import {Response} from '../../../../../../_metronic/helpers'
import {Employers, EmployersQueryResponse} from './_models'
import {getToken} from '../../../../auth'

//BASE_URL LINK
const API_URL = process.env.REACT_APP_API_URLS

//ROLE API URL
// const CREATE_EMPLOYERS_URL = `${API_URL}/employees/add`
const GET_EMPLOYERS_URL = `${API_URL}/employer/query`
const VIEW_EMPLOYERS_URL = `${API_URL}/employer/view`
// const UPDATE_EMPLOYERS_URL = `${API_URL}/employee/update`
// const DELETE_EMPLOYERS_URL = `${API_URL}/employee/delete`
// const GET_ROLE_URL = `${API_URL}/employees/getRole`

//AuthVerify
// var AuthVerify = getToken.call(this)

//EMPLOYEE LIST
const getEmployers = (query: string): Promise<EmployersQueryResponse> => {
  return axios
    .get(`${GET_EMPLOYERS_URL}/?${query}`, getToken())
    .then((response: AxiosResponse<EmployersQueryResponse>) => {
      return response.data
    })
}

//EMPLOYEE VEIW
const viewEmployers = (id: any) => {
  console.log("viewEmployers--apiii--id",id)
  return axios
    .get(`${VIEW_EMPLOYERS_URL}/${id}`,getToken())
    .then((response) => {
    
    return response.data;
    }
    )
}

//EMPLOYEE ADD
// const createEmployee = (data: FormData): Promise<Employee | undefined> => {
//   return axios.post(CREATE_EMPLOYEE_URL, data, getToken()).then((response: any) => response.data)
// }


//EMPLOYEE UPDATE
// const updateEmployers = (data: FormData, id: any) => {
//   console.log('reqData', data)
//   return axios.put(`${UPDATE_EMPLOYERS_URL}/${id}`, data, getToken()).then((response) => {
//     return response.data
//   })
// }

//EMPLOYEE DELETE
// const deleteEmployeeById = (id: any) => {
//   return axios.post(`${DELETE_EMPLOYEE_URL}/${id}`, AuthVerify).then((response) => {
//     return response.data
//   })
// }

//GET ROLE
// const getRole = async () => {
//   const res = await axios.get(`${GET_ROLE_URL}`, getToken())
//   console.log('roleList=>', res)
//   return res
// }

// export {getEmployers, createEmployers, viewEmployers, updateEmployers, deleteEmployersById}
export {getEmployers, viewEmployers}

